export default function StatsBar() {
  const stats = [
    { id: 'stat-replies', value: '1.4M+', label: 'Replies generated' },
    { id: 'stat-time', value: '8 sec', label: 'Average generation time' },
    { id: 'stat-restaurants', value: '2,400+', label: 'Restaurants using ReviewReply' },
    { id: 'stat-rating', value: '4.9 / 5', label: 'Average owner satisfaction' },
  ];

  return (
    <div
      className="border-y py-10"
      style={{ backgroundColor: 'var(--secondary)', borderColor: 'var(--border)' }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats?.map((stat) => (
            <div key={stat?.id} className="text-center">
              <p
                className="text-3xl font-bold tabular-nums mb-1"
                style={{ color: 'var(--primary)', fontFamily: 'var(--font-serif)' }}
              >
                {stat?.value}
              </p>
              <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}